import { render, staticRenderFns } from "./MaterialUsing.vue?vue&type=template&id=7b208b29&scoped=true&"
import script from "./MaterialUsing.vue?vue&type=script&lang=js&"
export * from "./MaterialUsing.vue?vue&type=script&lang=js&"
import style0 from "./MaterialUsing.vue?vue&type=style&index=0&id=7b208b29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b208b29",
  null
  
)

export default component.exports